var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundNoMatchBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 700,
    viewBox: "0 0 1349 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_3526)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1349,
    height: 700,
    fill: "#286385"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.578,
    y: 137.54,
    width: 23.8444,
    height: 29.8056,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.624343
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1331.85,
    y: 207.589,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-172.902 1331.85 207.589)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.386498
  }, /*#__PURE__*/React.createElement("rect", {
    x: 726.529,
    y: 542.744,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(33.9704 726.529 542.744)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.0829094
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1225.38,
    y: 407.928,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(115.097 1225.38 407.928)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.146862
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.061,
    y: 120.404,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(166.816 313.061 120.404)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.982472
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.205,
    y: 270.993,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-12.677 318.205 270.993)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.495993
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1055.44,
    y: 125.367,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-141.465 1055.44 125.367)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.872245
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.473,
    y: 586.433,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(115.097 574.473 586.433)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.200788
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.3945,
    y: 473.696,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-73.0157 -10.3945 473.696)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.44799
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1004.64,
    y: 298.081,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-18.2539 1004.64 298.081)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.0226822
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.8594,
    y: 107.305,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-15.7199 26.8594 107.305)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.734701
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.619,
    y: 57.3784,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-8.11439 362.619 57.3784)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.054983
  }, /*#__PURE__*/React.createElement("rect", {
    x: 977.891,
    y: 541.162,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-65.9156 977.891 541.162)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.896157
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.572,
    y: 392.403,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(108.506 135.572 392.403)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("rect", {
    x: 204.82,
    y: 405,
    width: 23.8444,
    height: 29.8056,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.896157
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.814,
    y: 659.863,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(108.506 228.814 659.863)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.896157
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.8145,
    y: 613.923,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(108.506 26.8145 613.923)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1208.82,
    y: 276,
    width: 23.8444,
    height: 29.8056,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.896157
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1232.81,
    y: 530.863,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(108.506 1232.81 530.863)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.610049
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.682,
    y: 115.452,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-59.3244 616.682 115.452)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.230903
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.971,
    y: 638.896,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(120.168 569.971 638.896)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.93,
    y: 563.748,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-33.4649 400.93 563.748)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.903197
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1080.04,
    y: 681.395,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-126.254 1080.04 681.395)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.582871
  }, /*#__PURE__*/React.createElement("rect", {
    x: 871.512,
    y: 31.8965,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-145.522 871.512 31.8965)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.211644
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.59,
    y: 353.965,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(60.8441 584.59 353.965)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.075987
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1241.43,
    y: 358.999,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(-131.831 1241.43 358.999)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.896157
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1351.81,
    y: 629.923,
    width: 23.8444,
    height: 29.8056,
    transform: "rotate(108.506 1351.81 629.923)",
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_3526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1349,
    height: 700,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundNoMatchBlue);
export default __webpack_public_path__ + "static/media/background_noMatch_blue.a844044fbcb0efd8f654da02a6e7ef88.svg";
export { ForwardRef as ReactComponent };